import apisauce from 'apisauce';
import { getApiBaseUrl, addErrorHandler } from '../serviceUtils';
import auth from '../../services/auth/AuthProvider';

/**
 * API for managing workflow information
 * @param {Array} errorCodes
 * @param {Object} headers
 * @param {number} timeout
 */
const create = (options = {}) => {  // this will change for prod deployment
    const {errorCodes = [], additionalHeaders = {}, timeout = 20000, unAuthorizedFunction = null } = options;
    const baseURL = getApiBaseUrl();
    const headers = { 'Cache-Control': 'no-cache', 'Content-Type': 'application/json' };

    // Validate additionalHeaders is an object/dictionary
    if (additionalHeaders && typeof additionalHeaders === 'object' && !Array.isArray(additionalHeaders)) {
        for (const key in additionalHeaders) {
            if (additionalHeaders.hasOwnProperty(key)) {
                headers[key] = additionalHeaders[key];
            }
        }
    } else if (additionalHeaders !== null && additionalHeaders !== undefined) {
        console.warn('additionalHeaders must be an object/dictionary, received:', typeof additionalHeaders);
    }

    // Create and configure an apisauce-based api object.
    const api = apisauce.create({
        baseURL,
        timeout
    });

    addErrorHandler(api, errorCodes, unAuthorizedFunction);

    const getAnonymous = (path) => {
        return api.get(path, {}, { headers });
    }

    const get = async (path) => {
        await AddAuthHeader();
        return api.get(path, {}, { headers });
    }
    const getWithPayload = async (path, payload) => {
        await AddAuthHeader();
        return api.get(path, payload, { headers });
    }
    const getBlob = async (path) => {
        await AddAuthHeader();
        return api.get(path, {}, { responseType: 'blob', headers });
    }

    const put = async (path, payload) => {
        await AddAuthHeader();
        return api.put(path, payload, { headers });
    }
    const post = async (path, payload) => {
        await AddAuthHeader();
        return api.post(path, payload, { headers });
    }

    const upload = async (path, payload, config) => {
        await AddAuthHeader();
        return api.post(path, payload, {
            headers,
            ...config
        });
    }
    const deleteRequest = async (path) => {
        await AddAuthHeader();
        return api.delete(path, {}, { headers });
    }

    const AddAuthHeader = async () => {
        if (auth.isAuthenticated()) {
            const token = await auth.getAccessToken();
            headers['Authorization'] = 'Bearer ' + token;
        }
    }

    // Return back a collection of functions
    return {
        getAnonymous, get, getWithPayload, put, post, deleteRequest, getBlob, upload
    }
}

const cancelToken = apisauce.CancelToken.source();
const isCancel = (ex) => apisauce.isCancel(ex);

// let's return back our create method as the default.
export default {
    create,
    cancelToken,
    isCancel
}